export default __webpack_public_path__ + "static/media/Home.6e337b65.svg";